import axiosBase from "../axiosBase";

export const apiLoadNews = (page) => () => axiosBase.get("news/?page=" + page);

export const apiLoadNewsMain = () =>
  axiosBase.get("block/page/main?parent=newsMain");
